import React from 'react';

const ContractTypePage = React.lazy(() => import('pages/ContractType/ContractTypePage'));
const ContractTypeAddPage = React.lazy(() => import('pages/ContractType/ContractTypeAddPage'));

const contractType = [
  {
    path: '/contract-type',
    exact: true,
    name: 'Danh sách loại hợp đồng',
    function: 'HR_CONTRACT_VIEW',
    component: ContractTypePage,
  },
  {
    path: '/contract-type/add',
    exact: true,
    name: 'Thêm loại hợp đồng',
    function: 'HR_CONTRACT_ADD',
    component: ContractTypeAddPage,
  },
  {
    path: '/contract-type/edit/:contract_type_id',
    exact: true,
    name: 'Chỉnh sửa loại hợp đồng',
    function: 'HR_CONTRACT_EDIT',
    component: ContractTypeAddPage,
  },
  {
    path: '/contract-type/detail/:contract_type_id',
    exact: true,
    name: 'Chi tiết loại hợp đồng',
    function: 'HR_CONTRACT_VIEW',
    component: ContractTypeAddPage,
  },
];

export default contractType;
